import http from "../http-common";
import authHeader from "./auth-header";

class UserService {
  getAllFilter(params = {}) {
    return http.get("/user/filter", { 
      headers: authHeader(), 
      params: params 
    });
  }

  getById(id) {
    return http.get(`/user/${id}`, { headers: authHeader() });
  }

  saveUser(user) {
    return http.post("/user", user, { headers: authHeader() });
  }

  resetPassword(userId) {
    return http.post(`/user/${userId}/reset-password`, {}, { headers: authHeader() });
  }

  updateUser(userId, userData) {
    return http.put(`/user/${userId}`, userData, { headers: authHeader() });
  }

  deleteUser(userId) {
    return http.delete(`/user/${userId}`, { headers: authHeader() });
  }
}

export default new UserService();